import classNames from "classnames"
import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import { Dialog } from "primereact/dialog"
import React from "react"

function LoteDialog({ close, loteInfo }) {
    const header = (<h3 className="text-2xl"><b>Informação de Inadimplente na carga</b></h3>)

    return (
        <Dialog
            visible
            onHide={() => close()}
            maximizable={true}
            header={header}
            pt={{
                root: ({ state }) => ({
                    className: classNames('rounded-lg shadow-lg border-0', 'max-h-[90%] transform scale-100',
                        'm-0 w-[90vw]',
                        'dark:border dark:border-blue-900/40', {
                        'transition-none transform-none !w-screen !h-screen !max-h-full !top-0 !left-0': state.maximized
                    })
                }),
                header: classNames('flex items-center justify-between shrink-0',
                    'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
                    'dark:bg-gray-900  dark:text-white/80'),
                content: ({ state }) => ({
                    className: classNames('overflow-auto w-full max-h-[85vh]',
                        'bg-white text-gray-700 px-6 pb-8 pt-0',
                        'rounded-bl-lg rounded-br-lg',
                        'dark:bg-gray-900 dark:text-white/80 ', {
                        "grow max-h-screen": state.maximized
                    })
                }),
            }}
        >
            <DataTable
                value={loteInfo}
                rows={5}
                size="small"
                paginator
                scrollHeight="45vh"
                scrollable
            >
                <Column
                    header="status_carga"
                    field="status_carga"
                />
                <Column
                    header="nome_devedor"
                    field="nome_devedor"
                />
                <Column
                    header="documento_devedor"
                    field="documento_devedor"
                />
                <Column
                    header="data_nascimento"
                    field="data_nascimento"
                />
                <Column
                    header="descricao_debito"
                    field="descricao_debito"
                />
                <Column
                    header="vencimento"
                    field="vencimento"
                />
                <Column
                    header="valor"
                    field="valor"
                />
                <Column
                    header="codigo_debito"
                    field="codigo_debito"
                />
                <Column
                    header="numero_cliente"
                    field="numero_cliente"
                />
                <Column
                    header="juros"
                    field="juros"
                />
                <Column
                    header="multa"
                    field="multa"
                />
                <Column
                    header="quantidade_parcelas_boleto"
                    field="quantidade_parcelas_boleto"
                />
                <Column
                    header="endereco_devedor"
                    field="endereco_devedor"
                />
                <Column
                    header="numero_devedor"
                    field="numero_devedor"
                />
                <Column
                    header="complemento_devedor"
                    field="complemento_devedor"
                />
                <Column
                    header="bairro_devedor"
                    field="bairro_devedor"
                />
                <Column
                    header="cidade_devedor"
                    field="cidade_devedor"
                />
                <Column
                    header="uf_devedor"
                    field="uf_devedor"
                />
                <Column
                    header="cep_devedor"
                    field="cep_devedor"
                />
                <Column
                    header="telefone_devedor"
                    field="telefone_devedor"
                />
                <Column
                    header="email_devedor"
                    field="email_devedor"
                />
            </DataTable>
        </Dialog>
    )
}

export default LoteDialog